import { css } from "emotion";
import { Link } from "preact-router/match";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import successIcon from "../../assets/images/icon-success.svg";
import ActionButton from "../../components/ActionButton";
import InputField from "../../components/fields/InputField";
import MultipleOptionsField from "../../components/fields/MultipleOptionsField";
import { add } from "../../state/actions/waitlistActions";
import { scrollToErrors } from "../../utils/ScrollToErrors";
import { email, required } from "../../utils/Validators";
import ActionBar from "../ActionBar";

const formWrapper = css({
  minWidth: 400,
  "@media(max-width: 600px)": {
    minWidth: 200
  }
});

let WaitlistForm = ({
  add,
  waitlist,
  event,
  ticketSelection,
  handleSubmit,
  ticket
}) => {
  const save = values => {
    const ticketIds = values.ticketIds.split("{|}");
    const data = {
      ...values,
      ticketIds,
      eventId: event.data._id
    };
    add(data);
  };
  const dateOptions = event.data.dates.reduce((options, date) => {
    options.push({
      label: `${date.display.time}, ${date.display.date}`,
      _id: date._id
    });
    return options;
  }, []);
  const ticketOptions = ticketSelection.tickets.reduce((options, ticket) => {
    if (ticket.showWaitlist) {
      options.push({
        label: ticket.name,
        _id: ticket._id
      });
    }
    return options;
  }, []);

  if (waitlist.add.added) {
    return (
      <div className={formWrapper}>
        <div
          style={{
            background: `url(${successIcon}) no-repeat center`,
            backgroundSize: 120,
            padding: "170px 0 40px 0",
            textAlign: "center"
          }}
        >
          <h3>Added to waitlist</h3>
        </div>
      </div>
    );
  }

  return (
    <div className={formWrapper}>
      <form onSubmit={handleSubmit(save)}>
        {waitlist && waitlist.add.error ? (
          <p class="text-error">{waitlist.add.error}</p>
        ) : (
          ""
        )}
        <Field
          label="First name"
          type="text"
          name="firstName"
          component={InputField}
          required={true}
          disabled={waitlist.add.loading}
          validate={required}
        />
        <Field
          label="Last name"
          type="text"
          name="lastName"
          component={InputField}
          required={true}
          disabled={waitlist.add.loading}
          validate={required}
        />
        <Field
          label="Email"
          type="email"
          name="email"
          component={InputField}
          required={true}
          disabled={waitlist.add.loading}
          validate={[required, email]}
        />

        {event.data.dates.length > 1 ? (
          <Field
            label="Which dates are interested in?"
            type="text"
            name="eventDateIds"
            formName="waitlist"
            disabled={waitlist.add.loading}
            component={MultipleOptionsField}
            valueField="_id"
            options={dateOptions}
          />
        ) : null}

        <Field
          label="Which tickets are interested in?"
          type="text"
          name="ticketIds"
          formName="waitlist"
          disabled={waitlist.add.loading}
          component={MultipleOptionsField}
          valueField="_id"
          validate={[required]}
          options={ticketOptions}
        />

        <ActionBar>
          <ActionButton
            disabled={waitlist.add.loading}
            loading={waitlist.add.loading}
          >
            Join
          </ActionButton>
          <Link
            style={{
              padding: "18px 0px",
              display: "inline-block"
            }}
            href={`/${event.data.slug}`}
          >
            Cancel
          </Link>
        </ActionBar>
      </form>
    </div>
  );
};

WaitlistForm = reduxForm({
  form: "waitlist",
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(WaitlistForm);

export default connect(
  (state, ownProps) => {
    return {
      initialValues: {
        ticketIds: ownProps.ticket._id,
        eventDateIds: [state.ticketSelection.selectedDateId]
      },
      event: state.event,
      ticketSelection: state.ticketSelection,
      waitlist: state.waitlist,
      ticketSelection: state.ticketSelection
    };
  },
  { add }
)(WaitlistForm);



// WEBPACK FOOTER //
// ./components/waitlist/WaitlistForm.js